import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getScriptBlockTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];

	return [
		{
			id: 'script',
			selector: '[data-tour="script"]',
			content:
				'This is the block of code that will be executed that is written in plain TypeScript.\n' +
				'The provided function must remain as is, however the content of the function can be modified in any way needed.',
		},
		{
			id: 'feedback',
			selector: '[data-tour="feedback"]',
			content:
				'This box will contain feedback information of the provided script such as errors and warnings.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
